import {ImbalanceItem, MonthOption, PersistentImbalanceExport} from "./types";

export function toSku(item: {material: string; size: string; coo: string; quality: string}): string {
    return `${item.material}-${item.size}-${item.coo}-${item.quality}`;
}

export function totalCi(item: ImbalanceItem): number {
    return item.ciTotalQty;
}

export function adjUnits(item: ImbalanceItem): number {
    return Math.abs(item.persistentImbalance);
}

export function generateMonthOptions(): MonthOption[] {
    const now = new Date();
    const opts: MonthOption[] = [];
    for (let i = 0; i < 6; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        opts.push({
            label: d.toLocaleDateString('en-GB', {month: 'short', year: 'numeric'}),
            value: `${yyyy}-${mm}`,
            threshold: i + 1,
        });
    }
    return opts;
}

export function exportPersistentImbalancesCsv(items: PersistentImbalanceExport[]) {
    const header = 'SKU,Latest Imbalance,Direction,' +
        'Persistent 1m,Persistent 2m,Persistent 3m,Persistent 4m,' +
        'Persistent 6m,Persistent 12m\n';
    let csv = header;
    items.forEach(item => {
        const sku = toSku(item);
        csv += [
            sku,
            item.imbalance, item.direction,
            item.persistent1m, item.persistent2m, item.persistent3m,
            item.persistent4m, item.persistent6m, item.persistent12m,
        ].join(',') + '\n';
    });
    const blob = new Blob([csv], {type: 'text/csv'});
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'persistent-imbalances-ELC.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
